// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"129bc33f","391":"aaf11ea8","551":"2643e3a6"}[chunkId] + ".chunk.js";
};